const { colors } = require('../../colors');

const button = {
  button: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: '400',
  },
};

const heading1 = {
  heading1: {
    fontSize: '24px',
    lineHeight: '32px',
    fontWeight: '400',
    color: colors['gray']['9'],
  },
};

const heading2 = {
  heading2: {
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: '600',
    color: colors['gray']['9'],
  },
};

const heading3 = {
  heading3: {
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: '400',
    color: colors['gray']['9'],
  },
};

const heading4 = {
  heading4: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: '400',
    color: colors['gray']['9'],
  },
};

const heading5 = {
  heading5: {
    fontSize: '14px',
    lineHeight: '22px',
    fontWeight: '400',
    color: colors['gray']['9'],
  },
};

const body = {
  body: {
    fontSize: '14px',
    lineHeight: '22px',
    fontWeight: '400',
    color: colors['gray']['9'],
  },
};

const bodySmall = {
  bodySmall: {
    fontSize: '12px',
    lineHeight: '20px',
    fontWeight: '400',
    color: colors['gray']['9'],
  },
};

module.exports = {
  ...button,
  ...heading1,
  ...heading2,
  ...heading3,
  ...heading4,
  ...heading5,
  ...body,
  ...bodySmall,
};
